import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import InfoGraphic from '../../svg/info-graphic.js';
import Footer from './footer.js';

class Info extends React.Component {
  render() {
    let info = DataStore.getPageBySlug('info');

    return (
      <div>
        <Layout>
          <section className="info-section">
            <div className="cnt">

                <div className="thumb-cnt">
                {info.acf.ilianna_photo !== null & info.acf.ilianna_photo !== undefined && info.acf.ilianna_photo ?
                  <img src={info.acf.ilianna_photo.url} alt={info.acf.ilianna_photo.title} />:null }

                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
                <InfoGraphic />
                <div className="bio">
                  <div className="cnt">
                    <div className="bio-text" dangerouslySetInnerHTML={{__html:info.content.rendered}} />
                  </div>

                  <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
                <div className="contact-cnt">
                  <div className="cnt">
                    <div className="contact">
                      <h2>Contact</h2>
                      <div dangerouslySetInnerHTML={{__html:info.acf.contact}} />
                    </div>
                    {info.acf.jobs !== null && info.acf.jobs.length > 0 ?
                      <div className="jobs">
                        <h2>Jobs</h2>
                        <div dangerouslySetInnerHTML={{__html:info.acf.jobs}} />
                      </div>:null
                    }

                    <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  </div>
                  <div className="ipad-crosses">
                    <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  </div>
                </div>
            </div>
          </section>
        </Layout>
        <Footer footerClass="contact" />
      </div>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/scripts/components/info.js